import { DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import { Button, Menu } from 'antd';
import DataNode from '../../../../interfaces/dataRoom/dataNode';
import { MenuInfo } from 'rc-menu/lib/interface';
import { useDownload } from '../../../../hooks/useDownload';
import { useCallback } from 'react';
export enum Action {
  AddFolder = 'AddFolder',
  Edit = 'Edit',
  Delete = 'Delete',
  Download = 'Download',
  Permissions = 'Permissions',
}
const FileMenu = ({
  item,
  t,
  onMenuClick,
  isEditable,
  propertyId,
}: {
  item: DataNode;
  t: any;
  onMenuClick: (event: MenuInfo, item: DataNode) => void;
  isEditable: boolean;
  propertyId: string;
  selectedIds?: Array<string>;
}) => {
  const { downloadSingleFile, downloadFiles } = useDownload();
  const download = useCallback(() => {
    (async () => {
      if (item.isFolder) {
        await downloadFiles(parseInt(propertyId), [item.id]);
      } else {
        const { url } =
          (await downloadSingleFile(parseInt(propertyId), item.id)) ?? {};
        if (url) {
          window.open(url, '_blank');
        }
      }
    })();
  }, [downloadSingleFile, downloadFiles, propertyId, item.id, item.isFolder]);
  return (
    <Menu
      onClick={event => {
        onMenuClick(event, item);
      }}
    >
      {isEditable && (
        <Menu.Item key={Action.Delete} icon={<DeleteOutlined />}>
          {t(`f:dataRoom.deleteFile`)}
        </Menu.Item>
      )}
      <Menu.Item icon={<DownloadOutlined />}>
        <Button
          onClick={download}
          type="text"
          className="ant-dropdown-menu-item"
          style={{ padding: 0 }}
        >
          {t(`f:dataRoom.download`)}
        </Button>
      </Menu.Item>
    </Menu>
  );
};
export default FileMenu;
